import React from 'react'
import { Card, CardActionArea, CardContent, Chip, Grid, makeStyles, Typography } from '@material-ui/core'
import { toDateTime } from '../../shared/functions/toDateTime';
import ShippingDetails from './ShippingDetails';

const useStyle = makeStyles({
    root: {
      minWidth: 300,
      maxWidth: 350,
    },
    media: {
      height: 140,
    },
    title : {
        color:'orange',
        fontWeight: 'bold',
        fontSize:14,
        padding:0
      }
  });

const ShippingCard = ({shipping}) => {
    const classes = useStyle()
    const {ActivityStatus, ContainerCode, CreateAt, UserName, Notes} = shipping
    const [open, setOpen] = React.useState(false);
    const [statusColor, setStatusColor] = React.useState('')

    React.useEffect(()=>{

        switch (ActivityStatus) {
            case 'InShipping':
                setStatusColor('#DBB926')
                break;
            case 'Shipped':
                setStatusColor('#254EDB')
                break;
            case 'Received':
                setStatusColor('#80D82D')
                break;
            default:
                break;
        }
    },[ActivityStatus])


    
    const handleClose=()=>{
        setOpen(false)
    }

    const handleOpen=()=>{
        setOpen(true)
    }

    

    return (
        <Card className={classes.root} >
            {open && <ShippingDetails shipping={shipping} handleClose={handleClose} />}
            <CardContent>
                <Grid container justify="space-between" >
                    <Typography> {ContainerCode} </Typography>
                    <Chip label={ActivityStatus} style={{backgroundColor: statusColor, color:'white'}} />
                </Grid>
            </CardContent>
            <CardActionArea onClick={handleOpen}>
                <CardContent>
                    <Grid container justify="space-between">
                        <Typography> {toDateTime(CreateAt?.seconds).toLocaleString()} </Typography>
                        <Typography> {UserName} </Typography>
                    </Grid>
                    <Grid container style={{marginBottom:-10, marginTop:10}}>
                    {Notes &&  <Typography variant="caption">Note : {Notes} </Typography>}
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default ShippingCard
